import { FieldCollector } from '../model';
import { CommonFieldCollector } from './commonFieldCollector';
import { FileUploadFieldCollector } from './fileUploadFieldCollector';
import { InformationFieldCollector } from './informationFieldCollector';

export const GeneralFieldCollector: FieldCollector = {
  collect: (schema, field) => {
    const collectors: FieldCollector[] = [
      FileUploadFieldCollector,
      InformationFieldCollector,
      CommonFieldCollector,
    ];
    const collector = collectors.find((collector) =>
      collector.shouldCollect(field),
    );

    if (collector) {
      collector.collect(schema, field);
    }
  },
  shouldCollect: (_) => {
    return true;
  },
};
